import { Chip } from '@mui/material';
import { PLAN_STATUS } from '../../shared/AppConstants';

const PLAN_STRATUS_BADGES = {
  SCI_EDIT: (
    <Chip
      icon={<fuel-icon name={'edit'} />}
      variant={'badge'}
      color={'warning'}
      label={PLAN_STATUS.SCI_EDIT}
    ></Chip>
  ),
  SBM_REVIEW: (
    <Chip
      icon={<fuel-icon name={'history'} />}
      variant={'badge'}
      color={'informational'}
      label={PLAN_STATUS.SBM_REVIEW}
    ></Chip>
  ),
  REVIEW_COMPLETE: (
    <Chip
      icon={<fuel-icon name={'check_circle'} />}
      variant={'badge'}
      color={'success'}
      label={PLAN_STATUS.REVIEW_COMPLETE}
    ></Chip>
  )
};
export const PlanStatusBadge = ({ planStatus }) => {
  switch (planStatus) {
    case PLAN_STATUS.SCI_EDIT:
      return PLAN_STRATUS_BADGES.SCI_EDIT;
    case PLAN_STATUS.SBM_REVIEW:
      return PLAN_STRATUS_BADGES.SBM_REVIEW;
    case PLAN_STATUS.REVIEW_COMPLETE:
      return PLAN_STRATUS_BADGES.REVIEW_COMPLETE;
    default:
      return PLAN_STRATUS_BADGES.SCI_EDIT;
  }
};
